import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { SCOUT_VARIATION_LIST } from '../../../../../../../constants';
import WithLabel, { LABEL_STYLES } from '../../../../../../../components/with-label/WithLabel';
import CommonTextarea from '../../../../../../../components/common-textarea/CommonTextarea';

import scss from './ConsiderSection.module.scss';

function ConsiderSection() {
  const { t } = useTranslation('scout');

  const variationScores = useSelector((state) => state.scout.variationScore);
  const isVariationLoading = useSelector((state) => state.scout.isVariationLoading);

  return (
    <div className={scss.variationsList}>
      {SCOUT_VARIATION_LIST.map(({ value, label }) => (
        <WithLabel variant={LABEL_STYLES.ROW} label={t(label)} key={label} isBold maxWidth={500}>
          <CommonTextarea
            value={clearExtraSymbols(isVariationLoading || variationScores[value])}
            isReadOnly
            rows='3'
            resize='none'
          />
        </WithLabel>
      ))}
    </div>
  );
}

export default ConsiderSection;

const clearExtraSymbols = (input) => {
  if (!input || typeof input !== 'string') {
    return '';
  }

  return input
    .split('\n')
    .map((line) => line.trim().replace(/["|,]/g, ''))
    .filter((line) => line)
    .join('\n');
};
